import { render, staticRenderFns } from "./SendEmailPass.vue?vue&type=template&id=b7036ce4&"
import script from "./SendEmailPass.vue?vue&type=script&lang=js&"
export * from "./SendEmailPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports